import UseContext from 'hooks/useContext';
import { NO_GROUPING } from './useMonthInvoices';

// In the order of the select.
const DISPLAY_MODE_OPTIONS = [
  { value: NO_GROUPING, key: 'all', fallback: 'Toutes les factures' },
  { value: 'company', key: 'byCompany', fallback: 'Par entreprise' },
  { value: 'group', key: 'byGroup', fallback: 'Par groupe' },
];

// The same look as the filters of the list.
const SELECT_CLASS_NAME =
  'w-full h-10 pl-2 pr-3 ft-b border rounded-md text-sm focus:border-yellow-500 focus:outline-none';

/**
 * The display choice in the header of "Facturation", next to the status
 * (JBWEB-1309): every invoice, by company or by group. Like the status, its
 * name « Affichage » is only read out, not shown. The values are those of
 * `useInvoiceDisplayMode`.
 */
const InvoiceDisplayModeSelect = ({ displayMode, onDisplayModeChange }) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.displayMode.${key}`, fallback);

  return (
    <div className="max-w-[200px]">
      <select
        aria-label={text('label', 'Affichage')}
        className={SELECT_CLASS_NAME}
        value={displayMode}
        onChange={(event) => onDisplayModeChange(event.target.value)}
      >
        {DISPLAY_MODE_OPTIONS.map(({ value, key, fallback }) => (
          <option key={value} value={value}>
            {text(key, fallback)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InvoiceDisplayModeSelect;
